import { render, staticRenderFns } from "./ResendEmailInfobox.vue?vue&type=template&id=7ff5ff19&scoped=true&"
import script from "./ResendEmailInfobox.vue?vue&type=script&lang=js&"
export * from "./ResendEmailInfobox.vue?vue&type=script&lang=js&"
import style0 from "./ResendEmailInfobox.vue?vue&type=style&index=0&id=7ff5ff19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff5ff19",
  null
  
)

export default component.exports